import { useId } from 'react';

/**
 * A page-unique id for a `<defs>` entry (gradient, mask): two copies of the same SVG on one page
 * would otherwise fight over a fixed id and one of them lose its paint. `useId` mixes in
 * separators (`:`, `«`) that a `url(#…)` reference cannot carry, hence the stripping.
 */
export const useSvgId = (prefix: string) => `${prefix}-${useId().replace(/\W/g, '')}`;
